// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3OOnb","footer":"ModalCreateQualiphyProcedure_footer__1H6nK","additionData":"ModalCreateQualiphyProcedure_additionData__3Dpxk"};